import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import HeaderFooterLayout from 'layouts/HeaderFooterLayout';

const Logout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: 'LOGOUT_REQUEST',
    });
    // eslint-disable-next-line
  }, []);

  return <HeaderFooterLayout />;
};

export default Logout;
